import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './Service.css';

const Services = () => {
    const [filteredPaper, setFilteredPaper] = useState([]);
    const [email, setEmail] = useState('');
    const [role, setRole] = useState('');
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const storedEmail = localStorage.getItem('email');
        const storedRole = localStorage.getItem('role');
        
        setEmail(storedEmail);
        setRole(storedRole);

        if (storedEmail && storedRole) {
            axios.get(`${process.env.REACT_APP_BACKEND_SERVER_URL}/api/v1/submit/get-paper-by-email-role`, {
                params: { email: storedEmail, role: storedRole }
            })
            .then(response => {
                setFilteredPaper(response.data?.data || []);
                setLoading(false);
            })
            .catch(error => {
                console.error('Error fetching data:', error);
                setLoading(false);
            });
        } else {
            setLoading(false);
        }
    }, []);

    return (
        <div className="history-container">
            <div className="history-header">
                <h1 className="history-title">Submission History</h1>
                <p className="history-subtitle">Your submitted papers and their status</p>
            </div>
    
            {loading ? (
                <div className="loading-state">Loading submissions...</div>
            ) : (
                filteredPaper.length > 0 ? (
                    <div className="history-table-container">
                        <table className="history-table">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Paper Title</th>
                                    <th>Presentation Type</th>
                                    <th>Document</th>
                                    <th>Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredPaper.map((paper, index) => (
                                    <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>{paper.title}</td>
                                        <td>
                                            {paper.presentationType || <span className="na-text">N/A</span>}
                                        </td>
                                        <td>
                                            {paper.cloudinaryURL ? (
                                                <a href={paper.cloudinaryURL} 
                                                   target="_blank" 
                                                   rel="noopener noreferrer"
                                                   className="paper-link">
                                                    View Paper
                                                </a>
                                            ) : (
                                                <span className="na-text">N/A</span>
                                            )}
                                        </td>
                                        <td>
                                            <span className={`status-badge ${paper.status?.toLowerCase()}`}>
                                                {paper.status || 'N/A'}
                                            </span>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                ) : (
                    <div className="no-papers">No submissions found</div>
                )
            )}
        </div>
    );
};

export default Services;